export default __webpack_public_path__ + "static/media/model-3.6dd276b2.jpg";